import { useState } from 'react';
import { ColumnFilter, ColumnFiltersState, PaginationState, SortingState, Updater } from '@tanstack/react-table';
import { allFilterOption, FROM, PAGE_SIZE } from 'app/constants';
import {
  ApplicationFilters,
  DomainFilters,
  ParticipantFilters,
  RemoteDomainFilters,
  RemoteParticipantFilters,
} from 'data';
// import { convertToQueryString, getInitialPaginationState, getInitialSortingState } from '../helpers';

export const useItemsListManagement = (
  filters:
    DomainFilters | RemoteDomainFilters | ParticipantFilters | RemoteParticipantFilters | ApplicationFilters | null,
  setFilters?: (value: React.SetStateAction<object>) => void,
) => {
  const [sorting, setSorting] = useState<SortingState>([{ id: 'name', desc: false }]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: FROM,
    pageSize: PAGE_SIZE,
  });
  const [globalFilter, setGlobalFilter] = useState<string>('');

  const onFiltersChange = (tableFilters: ColumnFiltersState) => {
    if (setFilters) {
      tableFilters.forEach((filter: ColumnFilter) =>
        setFilters((prevState) => {
          return {
            ...prevState,
            [filter.id]: filter.value === allFilterOption.value ? [] : filter.value,
          };
        }),
      );
    }
  };

  // const goToFirstPage = () =>
  //   setPagination((prevPagination) => ({
  //     ...prevPagination,
  //     pageIndex: 0,
  //   }));

  const onSortingChange = (sortState: Updater<SortingState>) => {
    setSorting(sortState);
    // goToFirstPage();
  };

  // useEffect(() => setSearchParams(convertToQueryString(filters, pagination, sorting)), [filters, pagination, sorting]);

  return {
    sorting,
    setSorting,
    pagination,
    setPagination,
    onFiltersChange,
    onSortingChange,
    globalFilter,
    setGlobalFilter,
    // searchParams,
  };
};
